<template>
  <div
    v-loading="loading"
    class="app-main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <div class="operations">
      <div class="triggers">
        <div style="margin-bottom: 4px;">
          <el-radio-group v-model="picCategory" style="margin-left: 5px;" @change="noChangeHandler">
            <el-radio
              :label="DocumentConstants.WAREHOUSE_PIC"
              style="margin-right: 5px;"
            >{{ $t('CargoMsg.Cargo_BangPic') }}</el-radio>
            <el-radio
              :label="DocumentConstants.LOADING_PIC"
            >{{ $t('SeaExport.PrintingPlatePhotos') }}</el-radio>
          </el-radio-group>
          <div
            style="display: inline-block;width: 70px;text-align: right;color: #666666;"
          >{{ picCategory === DocumentConstants.WAREHOUSE_PIC ? $t('SeaExport.ReceiptNo') : $t('Billing.WayBillNumber') }}</div>
          <el-input v-model="no" style="width: 150px;margin-left: 5px;" @change="noChangeHandler" />
          <el-button type="primary" @click="browseClickHandler">{{ $t('SeaExport.SelectFile') }}</el-button>
          <el-button type="primary" @click="$refs.picGrid.deleteHandler()">{{ $t('CargoMsg.Cargo_DeleteSelected') }}</el-button>
          <el-button type="primary" @click="startUploadHandler">{{ $t('CargoMsg.Cargo_StartUploading') }}</el-button>
          <el-button type="primary" @click="search_clickHandler">{{ $t('SeaExport.Query') }}</el-button>
          <el-button
            type="primary"
            @click="batchDownBtnClickHandler"
          >{{ $t('CargoMsg.Cargo_BatchDownload') }}</el-button>
        </div>
      </div>
    </div>
    <warehouse-pic-grid
      ref="picGrid"
      :model="model||{business_Document: ''}"
      :category="picCategory"
      :show-buttons="false"
      :enable-delete-old-pic="false"
      style="flex-grow: 1;"
      @uploadDone="uploadDoneHandler"
    />
  </div>
</template>

<script>
import warehousePicGrid from './components/routeCentral/warehousePicGrid'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import { AirExportFlightCustomer } from '@/class/model/booking/AirExportFlightCustomer'
import URL from '@/api/urlTranslator'
import { complexQuery } from '@/api/OMS/warehouseIn'
import { getJobByMBL, batchUpdate } from '@/api/AirExport/airExportJob'
import { saveAirExportFlightCustomer } from '@/api/AirExport/airExportFlightCustomer'

// 业务文档缓存
const businessDocumentCache = new Map()

export default {
  name: 'BatchUploadImage',
  components: { warehousePicGrid },
  data() {
    return {
      loading: false,
      DocumentConstants,
      picCategory: DocumentConstants.WAREHOUSE_PIC, // 照片类型
      no: '', // 回执单号/运单号
      model: null,
      isQuery: false,
      autoUpload: false
    }
  },
  watch: {
    model(newVal, oldVal) {
      if (oldVal && oldVal.business_Document && oldVal.business_Document.length > 0) {
        businessDocumentCache.set(oldVal.uuid, oldVal.business_Document.filter(p => !p.uuid)) // 缓存待上传的文件
      }
      this.$nextTick(() => {
        let addedBusinessDocuments = null
        if (newVal) {
          addedBusinessDocuments = businessDocumentCache.get(newVal.uuid) || null
        }
        this.$refs.picGrid.init(addedBusinessDocuments)
      })
    }
  },
  methods: {
    noChangeHandler() {
      this.model = null
    },
    async browseClickHandler() {
      if (this.checklbNo()) {
        this.isQuery = false
        this.autoUpload = false
        await this.checkNo()
        if (this.model) {
          this.$nextTick(() => {
            this.$refs.picGrid.selectHandler()
          })
        }
      }
    },
    startUploadHandler() {
      if (this.$refs.picGrid.rowData.filter(p => p.todo === 'new').length === 0) {
        this.$message.warning(this.$t('AirExport.PleaseImageYouWantUpload'))
        return
      }
      this.autoUpload = true
      this.checkNo()
    },
    search_clickHandler() {
      if (this.checklbNo()) {
        this.isQuery = true
        this.autoUpload = false
        this.model = null
        this.checkNo()
      }
    },
    checklbNo() {
      if (!this.no.trim()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + (this.picCategory === DocumentConstants.WAREHOUSE_PIC ? this.$t('SeaExport.ReceiptNo') : this.$t('Billing.WayBillNumber')) + '.')
        return false
      }
      return true
    },
    async checkNo() {
      if (!this.model) {
        let res
        switch (this.picCategory) {
          case DocumentConstants.WAREHOUSE_PIC:
            this.loading = true
            res = await complexQuery({ receiptNo: this.no, branchId: this.$store.getters.currentOfficeId, maxResult: 30 }).finally(() => {
              this.loading = false
            })
            if (!res.data || res.data.length === 0) {
              this.model = null
              this.$message.warning(this.$t('AirExport.InvalidReceiptNumber'))
              return
            }
            this.model = res.data[0]
            if (this.autoUpload) {
              await this.$refs.picGrid.upload()
            }
            break
          case DocumentConstants.LOADING_PIC:
            try {
              this.loading = true
              res = await getJobByMBL({ mbl: this.no }).finally(() => {
                this.loading = false
              })
              const job = res.data
              if (!job) {
                this.$message.warning(this.$t('AirExport.InvalidMasterBillNumber'))
              } else if (!job.voyageFlight) {
                this.$message.warning(this.$t('AirExport.NoContactTheAirlineImages'))
              } else {
                if (!job.airExportFlightCustomer && !this.isQuery) {
                  const airExportFlightCustomer = new AirExportFlightCustomer()
                  airExportFlightCustomer.flightNo = job.voyageFlight
                  airExportFlightCustomer.etd = job.etd
                  airExportFlightCustomer.customerId = job.customerId
                  this.loading = true
                  try {
                    await saveAirExportFlightCustomer(airExportFlightCustomer).then(res => {
                      job.airExportFlightCustomerUuid = res.data.uuid
                      job.airExportFlightCustomer = res.data
                    })
                    await batchUpdate([job], { airSelectiveType: 'airExportFlightCustomerUuid' }).then(res => {
                      job.version = res.data[0].version
                    })
                  } finally {
                    this.loading = false
                  }
                }
                this.model = job.airExportFlightCustomer
                this.model.job = job
                if (this.autoUpload) {
                  await this.$refs.picGrid.upload()
                }
              }
            } catch (err) {
              this.isQuery = false
            }
            break
        }
      } else if (this.autoUpload) {
        await this.$refs.picGrid.upload()
      }
    },
    batchDownBtnClickHandler() {
      const docs = this.$refs.picGrid.getSelectedFiles()
      if (this.model && docs.length > 0) {
        const fileIds = Array.from(docs, p => p.documentId).join(',')
        const fileName = this.no + '.zip'
        window.open(`${URL.common.compressFiles}?sessionId=${this.$store.getters.token}&fileIds=${fileIds}&fileName=${fileName}`)
      } else {
        this.$message.warning(this.$t('AirExport.PleaseFileYouWantDownload'))
      }
    },
    uploadDoneHandler() {
      this.$refs.picGrid.submit().then(() => {
        this.$confirm(this.$t('AirExport.UploadWantToUploadImage'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'info',
          closeOnClickModal: false
        }).then(() => {
          this.model = null
          this.no = ''
        }).catch(() => {
          this.$refs.picGrid.init()
        })
      })
    }
  }
}
</script>
